<div *ngIf="message" [ngClass]="message.cssClass" >{{message.text}} 
  <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
  <span aria-hidden="true">&times;</span>
</button></div>